module.exports = __webpack_public_path__ + "static/media/absensi.dede1453.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/absensi.png
// module id = 1597
// module chunks = 0